var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller('inspirationsController', ['$scope', 'inspirationService', 'randomService',
    function ($scope, inspirationService, randomService) {
        $scope.shoppingGalleryImageUrl = window.__env.shoppingGalleryImageUrl;
        function getCollectionsByCategoryId(category) {
            inspirationService.getcollectionsbycategoryid(category.id).then(
                function (response) {
                    if (response && response.data && response.data.length > 0) {
                        var currentCollection = randomService.getRandomItemsfromListArray(
                            response.data, 1
                        )[0];
                        currentCollection.categoryName = category.name;
                        currentCollection.description = category.description;
                        currentCollection.isNewCollection=inspirationService.isNewCollection(currentCollection.createdDate);
                        $scope.currentCollection = currentCollection;
                    }
                }
            );
        }
        $scope.getCategories = function () {
            inspirationService.getCollectionCategories().then(
                function (response) {
                    if (response && response.data && response.data.length > 0) {
                        $scope.categories = angular.copy(response.data);
                        getCollectionsByCategoryId(
                            response.data[0]
                        );
                    }
                }
            );
        }
               
        $scope.getCategories();     
    }
]);
